import styled from 'styled-components'

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 95%;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
  border-radius: 0 0 5px 5px;
  .MuiPaginationItem-root {
    border-radius: initial;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .Mui-selected {
    background-color: #616161 !important;
    color: white;

    &:hover {
      background-color: #757575;
    }
  }
`
